export default __webpack_public_path__ + "static/media/cda-square-logo.13ae0c82.png";